import { AddressModel, CustomerLocationsModel } from 'api';

/**
 * A single bookable (customer, location) pair, flattened out of the
 * hierarchical `CustomerLocationsModel[]` response so the Book Us click
 * handler can branch on the pair count (0 / 1 / 2+) without walking the
 * nested shape itself.
 */
export interface BookingContextPair {
    customerId: number;
    customerName: string;
    locationId: number;
    locationName: string;
    address?: AddressModel;
}

/**
 * Flattens `CustomerLocationsModel[]` into one entry per (customer, location)
 * pair. Every customer entry returned by `service-addresses` already has at
 * least one location (`UserCustomersService.GetCustomerLocationsAsync`
 * groups by customer), so there is no zero-location case to guard against
 * here.
 */
export const flattenBookingContextPairs = (
    customers: CustomerLocationsModel[]
): BookingContextPair[] =>
    customers.flatMap(customer =>
        customer.locations.map(location => ({
            customerId: customer.id,
            customerName: customer.name,
            locationId: location.id,
            locationName: location.name,
            address: location.address,
        }))
    );
